/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Intelligence_BasicInputs */

const en_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic AI Ingestion`)
};

const es_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestión básica de IA`)
};

const fr_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestion IA Basique`)
};

const de_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfache KI-Erfassung`)
};

const ja_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本的なAI取り込み`)
};

const zh_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础 AI 抓取`)
};

const ar_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استيعاب أساسي للذكاء الاصطناعي`)
};

const id_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inklusi AI Dasar`)
};

const it_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestione IA di Base`)
};

const ru_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый сбор данных ИИ`)
};

const pt_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestão Básica de IA`)
};

const ko_tier_feature_intelligence_basic = /** @type {(inputs: Tier_Feature_Intelligence_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 AI 데이터 수집`)
};

/**
* | output |
* | --- |
* | "Basic AI Ingestion" |
*
* @param {Tier_Feature_Intelligence_BasicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_intelligence_basic = /** @type {((inputs?: Tier_Feature_Intelligence_BasicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Intelligence_BasicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_intelligence_basic(inputs)
	if (locale === "es") return es_tier_feature_intelligence_basic(inputs)
	if (locale === "fr") return fr_tier_feature_intelligence_basic(inputs)
	if (locale === "de") return de_tier_feature_intelligence_basic(inputs)
	if (locale === "ja") return ja_tier_feature_intelligence_basic(inputs)
	if (locale === "zh") return zh_tier_feature_intelligence_basic(inputs)
	if (locale === "ar") return ar_tier_feature_intelligence_basic(inputs)
	if (locale === "id") return id_tier_feature_intelligence_basic(inputs)
	if (locale === "it") return it_tier_feature_intelligence_basic(inputs)
	if (locale === "ru") return ru_tier_feature_intelligence_basic(inputs)
	if (locale === "pt") return pt_tier_feature_intelligence_basic(inputs)
	return ko_tier_feature_intelligence_basic(inputs)
});